import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import { FaRegCalendarAlt } from "react-icons/fa";

import styles from "./PersianDateField.module.css";

const PersianDateField = ({
    id,
    name,

    label,

    value,

    onChange,
    onBlur,

    error,
    touched,

    hint,

    placeholder = "انتخاب تاریخ",

    required = false,

    disabled = false,
}) => {

    const hasError = Boolean(error && touched);

    /**
     * مقدار Formik همیشه ISO Date است
     * مثال:
     * 2026-07-03
     *
     * اینجا فقط برای نمایش به شمسی تبدیل می‌شود.
     */
    const pickerValue = value
        ? new DateObject(new Date(value))
              .convert(persian, persian_fa)
        : null;

    /**
     * خروجی DatePicker دوباره
     * به ISO تبدیل می‌شود.
     */
    const handleChange = (dateObject) => {

        if (!dateObject) {
    
            onChange("");
    
            return;
    
        }
    
        const jsDate = dateObject.toDate();
    
        const year = jsDate.getFullYear();
    
        const month = String(
    
            jsDate.getMonth() + 1
    
        ).padStart(2,"0");
    
        const day = String(
    
            jsDate.getDate()
    
        ).padStart(2,"0");
    
        onChange(
    
            `${year}-${month}-${day}`
    
        );
    
    };
    // const handleChange = (dateObject) => {

    //     if (!dateObject) {

    //         onChange("");

    //         return;

    //     }

    //     const isoDate = dateObject
    //         .toDate()
    //         .toISOString()
    //         .split("T")[0];

    //     onChange(isoDate);

    // };

    return (

        <div
            className={`${styles.wrapper} ${
                hasError ? styles.error : ""
            }`}
        >

            <div className={styles.label}>

                <span className={styles.icon}>
                    <FaRegCalendarAlt />
                </span>

                <span>

                    {label}

                    {

                        required &&

                        <small>*</small>

                    }

                </span>

            </div>

            <DatePicker

                id={id}

                name={name}

                value={pickerValue}

                calendar={persian}

                locale={persian_fa}

                format="YYYY/MM/DD"

                editable={false}

                disabled={disabled}

                placeholder={placeholder}

                calendarPosition="bottom-right"

                inputClass={styles.input}

                onOpenPickNewDate={false}

                onChange={handleChange}

                onClose={onBlur}

            />

            {

                hint &&

                !hasError &&

                <div className={styles.hint}>

                    {hint}

                </div>

            }

            {

                hasError &&

                <div className={styles.errorText}>

                    {error}

                </div>

            }

        </div>

    );

};

export default PersianDateField;